import React from 'react';
import { Suspense} from "react";
import Spinner from "./components/Utils/Spinner";
import { Canvas } from "@react-three/fiber";
import Experience from "./components/Experience";
import UIConfigurator from './components/UI/UIConfigurator';
import UIDetails from './components/UI/UIDetails';
import SaveUI from './components/Export/SaveUI';
import { useSelector } from 'react-redux';

import './App.css';

function App() {
  const hideShowSaveUI = useSelector(state => state.uiExportMenu.showSaveUi);
  const pdfIsGenerating = useSelector(state => state.uiExportMenu.pdfIsGenerating);
  const darkTheme = useSelector(state => state.uiMenuState.darkTheme);

  return (
    <div className="App">      
      <Suspense fallback={<Spinner />} > 
          {!pdfIsGenerating ? 
          <>
            <Canvas style={{position: "fixed"}}>
                <color attach="background" args={[darkTheme ? "#fcfcfc" : "#252a42"]} />
                <Experience />          
            </Canvas> 
            <UIConfigurator />  
            <UIDetails />
            {hideShowSaveUI && <SaveUI />} </>  
          : <Spinner/>         
          }                
      </Suspense>         
    </div>
  );
}

export default App;
